// src/pages/JobPage.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Job.css';
import '../services/ServicePage.css';
import hiringImage from '../../assets/services/hiring.jpg';

function Job() {
  return (
    <main className="service-page">
      {/* Hero Section */}
      <section className="service-hero" style={{ backgroundImage: `url(${hiringImage})` }}>
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <h1>Nous Recrutons!</h1>
          <p>Rejoignez notre équipe de chauffeurs professionnels</p>
        </div>
      </section>

      <section className="service-content">
        <div className="service-container">
          <div className="welcome-section">
            <h2>Jeune ou retraité, vous êtes le bienvenu !</h2>
            <p className="highlight-text">
              Le passé c'est du passé ! Ce qui nous intéresse : qu'allez-vous 
              rapporter de plus à notre compagnie ?
            </p>
          </div>

          <div className="job-features">
            <div className="feature">
              <i className="fas fa-users"></i>
              <h3>Équipe Dynamique</h3>
              <p>Intégrez une équipe accueillante et professionnelle</p>
            </div>

            <div className="feature">
              <i className="fas fa-clock"></i>
              <h3>Horaires Flexibles</h3>
              <p>Adaptez vos horaires selon vos disponibilités</p>
            </div>

            <div className="feature">
              <i className="fas fa-car"></i>
              <h3>Véhicules Modernes</h3>
              <p>Conduisez des véhicules confortables et bien entretenus</p>
            </div>
          </div>

          <div className="contact-section">
            <h3>Intéressé(e) ? Contactez-nous !</h3>
            <div className="contact-methods">
              <a href="tel:+41797774444" className="contact-method">
                <i className="fas fa-phone"></i>
                <span>079 777 44 44</span>
              </a>
              <a href="mailto:info@taxivd.ch" className="contact-method">
                <i className="fas fa-envelope"></i>
                <span>info@taxivd.ch</span>
              </a>
              <Link to="/quote" className="contact-method">
                <i className="fas fa-file-alt"></i>
                <span>Formulaire de contact</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Job;
